export enum MetadataAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export interface MetadataDiff {
  sobject: string;
  fields: { name: string; action: MetadataAction }[];
}
